export default "__VITE_ASSET__cVl0nJNi__"